var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"tab",class:{ active: _vm.value === index },on:{"click":function($event){return _vm.onTabKeyChange(index)}}},[_vm._v(_vm._s(tab))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }